import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  // return 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMzI2MjQxMjQ1NiIsImNyZWF0ZWQiOjE2MDUwNzU5ODQwNjgsImV4cCI6MTYwNTY4MDc4NH0.kOWutqnUm-6Ofmj6J1qqkOC-0qgIaQ0HFGYlwlMt8t_I4QN6zopSXQp6htnHIZVJzmd6I4JBi909zRWkFpNS1w'
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js